import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export default function AdminDiscussions() {
  const [discussions, setDiscussions] = useState(null);

  const load = () => api.get("/admin/discussions").then((res) => setDiscussions(res.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/discussions/${id}`, { status });
    toast.success("Discussion updated");
    load();
  };

  return (
    <div data-testid="admin-discussions-page">
      <h1 className="text-2xl font-serif-heading font-bold text-navy mb-6">Discussions Moderation</h1>
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>Title</TableHead><TableHead>Category</TableHead><TableHead>Author</TableHead><TableHead>Views</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
          <TableBody>
            {discussions?.map((d) => (
              <TableRow key={d.id} data-testid={`admin-discussion-row-${d.slug}`}>
                <TableCell className="font-medium text-navy max-w-xs truncate">{d.title}</TableCell>
                <TableCell><Badge variant="secondary">{d.category}</Badge></TableCell>
                <TableCell className="text-sm text-slate-500">{d.author_name}</TableCell>
                <TableCell className="text-sm text-slate-500">{d.view_count}</TableCell>
                <TableCell>
                  <Select value={d.status} onValueChange={(v) => updateStatus(d.id, v)}>
                    <SelectTrigger className="w-32 h-8" data-testid={`admin-discussion-status-${d.slug}`}><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="published">Published</SelectItem>
                      <SelectItem value="hidden">Hidden</SelectItem>
                    </SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
